import { useEffect, useMemo, useState } from "react";
import {
  Form,
  Grid,
  CheckboxProps
} from "antd";
import { QuestionType } from "../../types/survey";

const { useBreakpoint } = Grid;

const Question = ({ item }: { item: QuestionType }) => {
  const form = Form.useFormInstance();
  const [fieldDisabled, setFieldDisabled] = useState(false);
  const screens = useBreakpoint();

  const timeSlots: { [key: string]: string; } = {
    "Mattina": "",
    "Pomeriggio": "",
    "Sera": ""
  };

  const itemOptions = useMemo(() => JSON.parse(item.options ?? "[]"), [item]);

  const isTimeSlots = itemOptions.some((key: string) => key in timeSlots);

  useEffect(() => {
    if (form.getFieldValue(item.id) === null) {
      setFieldDisabled(true);
    }
  }, []);

  const handleCheckbox: CheckboxProps["onChange"] = (e) => {
    const isChecked = e.target.checked;

    setFieldDisabled(isChecked);
    form.setFieldValue(item.id, isChecked ? null : undefined);
  };

  const titleLevel: 2 | 3 = useMemo(() => (screens.md ? 2 : 3), [screens]);

  return {
    form,
    isTimeSlots,
    handleCheckbox,
    fieldDisabled,
    titleLevel,
    itemOptions,
    timeSlots,
  };
};

export default Question;
